<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2022-02-04 15:50:55
 * @LastEditTime: 2022-02-19 21:49:34
 * @FilePath: \raacfold\src\components\menu\Representation.vue
-->
<template>
    <div @mouseenter="enter_div" @mouseleave="leave_div" id="menu" class="color-skin" :style="{transform: menu_transform}" v-show="is_representation_show">
        <ul style="list-style: none; padding: 0px;margin: 0px">
            <!-- <li class="bm-menu-btn menu-li-headr"><strong>Representation</strong></li> -->
            <!--<li class="menu-li">Cancel</li>-->
            <hr style="margin: 0px">
            <li @mouseenter="enter('cartoon')" @mouseleave="leave('cartoon')" @click="representationClick('cartoon')" class="bm-menu-btn"><i class="icon-font icon-cartoon"></i> Cartoon</li>
            <li @mouseenter="enter('ribbon')" @mouseleave="leave('ribbon')" @click="representationClick('ribbon')" class="bm-menu-btn"><i class="icon-font icon-bianzu3"></i> Ribbon</li>
            <li @mouseenter="enter('rope')" @mouseleave="leave('rope')" @click="representationClick('rope')" class="bm-menu-btn"><i class="icon-font icon-rope1"></i> Rope</li>
            <li @mouseenter="enter('tube')" @mouseleave="leave('tube')" @click="representationClick('tube')" class="bm-menu-btn"><i class="icon-font icon-tube"></i> Tube</li>
            <li @mouseenter="enter('trace')" @mouseleave="leave('trace')" @click="representationClick('trace')" class="bm-menu-btn"><i class="icon-font icon-trace"></i> Trace</li>
            <hr style="margin: 0px">
            <li @mouseenter="enter('ball+stick')" @mouseleave="leave('ball+stick')" @click="representationClick('ball+stick')" class="bm-menu-btn"><i class="icon-font icon-danbaizhi"></i> Ball+stick</li>
            <li @mouseenter="enter('hyperball')" @mouseleave="leave('hyperball')" @click="representationClick('hyperball')" class="bm-menu-btn"><i class="icon-font icon-jiaohu"></i> Hyperball</li>
            <li @mouseenter="enter('licorice')" @mouseleave="leave('licorice')" @click="representationClick('licorice')" class="bm-menu-btn"><i class="icon-font icon-lianjie"></i> Licorice</li>
            <li @mouseenter="enter('line')" @mouseleave="leave('line')" @click="representationClick('line')" class="bm-menu-btn"><i class="icon-font icon-icon-"></i> Line</li>
            <li @mouseenter="enter('point')" @mouseleave="leave('point')" @click="representationClick('point')" class="bm-menu-btn"><i class="icon-font icon-xian1"></i> Point</li>
            <li @mouseenter="enter('backbone')" @mouseleave="leave('backbone')" @click="representationClick('backbone')" class="bm-menu-btn"><i class="icon-font icon-buguize"></i> Backbone</li>
            <hr style="margin: 0px">
            <li @mouseenter="enter('spacefill')" @mouseleave="leave('spacefill')" @click="representationClick('spacefill')" class="bm-menu-btn"><i class="icon-font icon-spacefill"></i> Spacefill</li>
            <li @mouseenter="enter('surface')" @mouseleave="leave('surface')" @click="representationClick('surface')" class="bm-menu-btn"><i class="icon-font icon-bingdu"></i> Surface</li>
            <hr style="margin: 0px">
            <li @mouseenter="enter('surface')" @mouseleave="leave('transparent')" @click="representationClick('transparent')" class="bm-menu-btn"><i class="el-icon-close"></i> Transparent</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "BaimocFooter",
    data() {
        return {
            menu_transform: "translate3d(100px, 0px, 0px)",
            current_range: [],
            menu_show: true,
            is_representation_show: false,
            multi: false,
            selected_color: '#FFFFFF',
            mouse_entered: false,
        };
    },
    watch: {
        "$store.state.sequence_menu"(data) {
            // console.log("$store.state.sequence_menu", data);
            this.is_show = data["isshow"];
            this.multi = data["multi"];
            this.render_menu(data);
        },
        "$store.state.selected_range"(data) {
            this.current_range = data;
        },
        show(val){
            // console.log("show", val)
            // console.log("mouse_entered", this.mouse_entered);
            // console.log("init", this.is_representation_show, val, this.mouse_entered);
            if (val){
                this.is_representation_show = true;
            }else{
                let vue_obj = this;
                setTimeout(function(){
                    if(vue_obj.mouse_entered !== undefined && vue_obj.mouse_entered===true){
                        vue_obj.is_representation_show = true;
                    }else{
                        vue_obj.is_representation_show = false;
                    }
                    // console.log(">>>", vue_obj.is_representation_show, val, vue_obj.mouse_entered);
                },10);
            }
        }
    },
    props: {
        show: Boolean,
    },
    mounted() {
        let sequence_menu = this.$store.state.sequence_menu;
        this.multi = sequence_menu["multi"];
    },
    methods: {
        render_menu(data) {
            let x = data["x"] + 119.5;
            // let y = data["y"] - 144;
            let y = data["y"] - 364;
            let leftWidth = data["leftWidth"];
            // 判断是否超出屏幕
            let menu_height = 320;
            let menu_width = 130;
            let screen_height = window.innerHeight;
            let screen_width = window.innerWidth;
            // let sequence_height = window.innerHeight - this.$store.state.structure_resize  - 120;
            // console.log(">>>>>", y , menu_height , sequence_height)
            if(y + menu_height > screen_height){
                y = y - menu_height
            }
            if(data["x"] + menu_width > screen_width){
                if(x + menu_width > screen_width){
                    x = x - menu_width - 239.5;
                }
            }else{
                if(x + menu_width > screen_width){
                    x = x - menu_width- 109;
                }
            }
            this.menu_transform = `translate3d(${
                x - leftWidth
            }px, ${y}px, 0px)`;
        },
        enter_div(){
            this.mouse_entered = true;
        },
        leave_div(){
            this.mouse_entered = false;
            this.is_representation_show = false;
        },
        enter() {},
        leave() {},
        representationClick(val) {
            let sequence_menu = this.$store.state.sequence_menu;
            let index = sequence_menu["index"]
            this.selected_color = sequence_menu["representation"][index] = val;
            sequence_menu["isshow"] = false;
            this.$store.commit("sequenceMenuMutation", sequence_menu);
            this.is_representation_show = false;
            // console.log("representationClick", this.$store.state.sequence_menu)
            // this.$emit('is_main_show', false);
        }
    },
};

</script>

<style scoped>
.menu-li-headr {
    font-weight: 900 !important;
    font-size: 14px !important;
    padding: 2px 5px 2px 10px;
    color: #2f3542;
    font-family: "OpenSans-Semibold", "Helvetica Neue", Helvetica, Arial,
        sans-serif !important;
    font-size: 12px;
    font-style: normal;
}
.color-skin {
    width: 120px;
    visibility: visible;
    position: absolute;
    display: block;
    border-style: solid;
    white-space: nowrap;
    z-index: 9999999999999999998;
    box-shadow: rgb(0 0 0 / 30%) 1px 2px 2px;
    transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
        visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s,
        transform 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
    background-color: rgb(255, 255, 255);
    border-width: 1px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    font: 14px / 21px "Microsoft YaHei";
    padding: 0px;
    border-color: #a4b0be;
    opacity: 0.95;
}
.bm-menu-btn {
    font-family: "OpenSans-Semibold", "Helvetica Neue", Helvetica, Arial,
        sans-serif !important;
    padding: 2px 5px 2px 10px;
    color: #2f3542;
    font-size: 12px;
    font-style: normal;
    cursor: pointer;
    /* box-shadow:0 1px 0 rgba(0,0,0,.2) inset,0 -1px 0 rgba(255,255,255,.2) inset; */
}
.bm-menu-btn:hover {
    background: #ecf0f1;
}
.bm-menu-btn-clicked {
    color: #1e90ff;
}
.bm-color {
    /* margin: 0 0 8px 8px; */
    width: 20px;
    height: 20px;
    border-radius: 4px;
    /* cursor: pointer; */
}
</style>
